import { render, staticRenderFns } from "./studentHot.vue?vue&type=template&id=c979e76e&scoped=true&"
import script from "./studentHot.vue?vue&type=script&lang=js&"
export * from "./studentHot.vue?vue&type=script&lang=js&"
import style0 from "./studentHot.vue?vue&type=style&index=0&id=c979e76e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c979e76e",
  null
  
)

export default component.exports